import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

// https://www.npmjs.com/package/react-datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';

import "react-datepicker/dist/react-datepicker.css";

function EditarRegulacion(props) {
	const { regulacionOriginal, guardar, setQueMostrar } = props

	registerLocale('es', es)

	const [datos, setDatos] = useState({
		id: regulacionOriginal.id,
		borrador: regulacionOriginal.borrador === '1',
		titulo: regulacionOriginal.titulo,
		contenido: regulacionOriginal.contenido,
		fechaCreacion: new Date(regulacionOriginal.fechaCreacion),
		fecha: new Date(regulacionOriginal.fecha),
		documento: false,
	})

	const [erroresValidacion, setErroresValidacion] = useState({})

	const handleClose = () => {
		setQueMostrar('')
		setDatos({})
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datos,
		}

		if (validarDatos()) {
			guardar(data)
			handleClose()
		}
	}

	const validarDatos = () => {
		const camposRequeridos = ['titulo']
		const nuevosErrores = {}

		camposRequeridos.forEach(campo => {
			if (datos[campo].trim() === '') {
				nuevosErrores[campo] = 'Este es un campo requerido'
			} else {
				nuevosErrores[campo] = null
			}
		})

		const errores = { ...erroresValidacion, ...nuevosErrores }

		setErroresValidacion(errores)

		return Object.keys(errores).filter(elem => errores[elem] !== null).length === 0
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value
		setDatos(prev => datosCopia)
	}

	const handleSeleccionDocumento = (files) => {
		setDatos({ ...datos, documento: files[0] })
	}

	const nombreOriginalArchivoPartes = regulacionOriginal.documento?.url.split('/')
	const nombreOriginalArchivo = nombreOriginalArchivoPartes[nombreOriginalArchivoPartes.length - 1]
	const extensionPartes = nombreOriginalArchivo.split('.')
	const extension = extensionPartes[extensionPartes.length - 1]

	const isPdf = extension === 'pdf'
	const isDoc = extension === 'docx' || extension === 'doc'

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Editar regulación sanitaria" />
			<Offcanvas.Body id="editar-regulacion">
				<h1>Campos de la regulación sanitaria</h1>
				{datos.id && (<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="regulacion-borrador">
										<Form.Check
											type="switch"
											label="Publicado"
											checked={!datos.borrador}
											onChange={(e) => handleChange(!e.target.checked, 'borrador')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="regulacion-titulo">
										<FormLabel>Título</FormLabel>
										<Form.Control
											value={datos.titulo}
											onChange={(e) => handleChange(e.target.value, 'titulo')}
											isInvalid={erroresValidacion.titulo}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.titulo}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="regulacion-contenido">
										<Form.Label>Contenido</Form.Label>
										<Form.Control
											as="textarea" rows={15}
											value={datos.contenido}
											onChange={(e) => handleChange(e.target.value, 'contenido')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="regulacion-fecha">
										<FormLabel>Fecha</FormLabel>
										<DatePicker
											selected={datos.fecha}
											onChange={(fecha) => handleChange(fecha, 'fecha')}
											locale='es'
											dateFormat="dd/MM/yyyy"
										/>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col sm={12} md={6}>
						{regulacionOriginal.documento && (
							<div className="text-center documento-actual">
								<h4>Documento seleccionado</h4>
								<i className={'fa ' + (isDoc ? 'fa-file-word' : (isPdf ? 'fa-file-pdf' : 'fa-file'))}></i> <a href={process.env.REACT_APP_API_URL + 'uploads/' + regulacionOriginal.documento.url}>{nombreOriginalArchivo}</a>
								<hr className="mb-5" />
							</div>
						)}
						<FileUpload
							title="Cambiar documento"
							accept=".pdf, .doc, .docx"
							buttonText="Elegir"
							buttonTextSingular="documento"
							updateFiles={handleSeleccionDocumento}
						/>
					</Col>
				</Row>)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarRegulacion